/// <amd-module name="typeahead/features/ElasticacheStalenessLogging" />
import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 35269,
            name: "ESS_Jupiter_UHS_to_BEX_API",
            value: 1,
        },
    },
];

export class BexApiMigration implements IExperimentalFeature {

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
